export const staticPrimaryColor = '#7B30F7'
export const staticPrimaryDarkenColor = '#7B30F7'
export const staticInfoColor = '#06A2F1'
export const staticWarningColor = '#E28A00'
export const staticErrorColor = '#FF4C51'
export const staticSuccessColor = '#48B500'

export const themes = {
    light: {
        dark: false,
        colors: {
            primary: staticPrimaryColor,
            'on-primary': '#fff',
            'primary-darken-1': staticPrimaryColor,
            secondary: '#8A8D93',
            'secondary-darken-1': '#FAAC84',
            'on-secondary': '#fff',
            success: staticSuccessColor,
            'success-darken-1': staticSuccessColor,
            'on-success': '#fff',
            info: staticInfoColor,
            'info-darken-1': staticInfoColor,
            'on-info': '#fff',
            warning: staticWarningColor,
            'warning-darken-1': staticWarningColor,
            'on-warning': '#fff',
            error: staticErrorColor,
            'error-darken-1': staticErrorColor,
            'on-error': '#fff',
            background: '#f4f5fa',
            'on-background': '#525252',
            surface: '#fff',
            'on-surface': '#525252',
            'grey-50': '#FAFAFA',
            'grey-100': '#F5F5F5',
            'grey-200': '#EEEEEE',
            'grey-300': '#E0E0E0',
            'grey-400': '#BDBDBD',
            'grey-500': '#9E9E9E',
            'grey-600': '#757575',
            'grey-700': '#616161',
            'grey-800': '#424242',
            'grey-900': '#212121',
            'perfect-scrollbar-thumb': '#dbdade',
            'skin-bordered-background': '#fff',
            'skin-bordered-surface': '#fff',
            'expansion-panel-text-custom-bg': '#fafafa',
            'track-bg': '#F0F2F8',
            'chat-bg': '#F7F6FA',

            'sky-blue': '#58A1D5',
            'deep-sky-blue': '#3587C2',
            'navy-blue': '#1F5685',
            'steel-blue': '#256BA4',
            tangerine: '#F58145',
            ivory: '#FFFEEA',
            'dark-charcoal': '#2F2F2F',
            'wood-charcoal': '#464646',
            'spanish-gray': '#989898',
            'traffic-red': '#ED151B',
        },
        variables: {
            'code-color': '#d400ff',
            'overlay-scrim-background': '#525252',
            'tooltip-background': '#1A0E33',
            'overlay-scrim-opacity': 0.5,
            'hover-opacity': 0.04,
            'focus-opacity': 0.1,
            'selected-opacity': 0.08,
            'activated-opacity': 0.16,
            'pressed-opacity': 0.14,
            'dragged-opacity': 0.1,
            'disabled-opacity': 0.4,
            'border-color': '#525252',
            'border-opacity': 0.12,
            'table-header-color': '#F6F7FB',
            'high-emphasis-opacity': 0.9,
            'medium-emphasis-opacity': 0.7,

            // 👉 shadows
            'shadow-key-umbra-color': '#525252',
            'shadow-xs-opacity': '0.16',
            'shadow-sm-opacity': '0.18',
            'shadow-md-opacity': '0.20',
            'shadow-lg-opacity': '0.22',
            'shadow-xl-opacity': '0.24',

            'nav-bg-color': '#F3F7FC',
            'inactive-color': '#525252',
        },
    },
    dark: {
        dark: true,
        colors: {
            primary: staticPrimaryColor,
            'on-primary': '#fff',
            'primary-darken-1': staticPrimaryColor,
            secondary: '#8A8D93',
            'secondary-darken-1': '#7C7F84',
            'on-secondary': '#fff',
            success: staticSuccessColor,
            'success-darken-1': staticSuccessColor,
            'on-success': '#fff',
            info: staticInfoColor,
            'info-darken-1': '#149FE6',
            'on-info': '#fff',
            warning: staticWarningColor,
            'warning-darken-1': staticInfoColor,
            'on-warning': '#fff',
            error: staticErrorColor,
            'error-darken-1': staticErrorColor,
            'on-error': '#fff',
            background: '#28243D',
            'on-background': '#E7E3FC',
            surface: '#312d4b',
            'on-surface': '#E7E3FC',
            'grey-50': '#2A2E42',
            'grey-100': '#2F3349',
            'grey-200': '#4A5072',
            'grey-300': '#5E6692',
            'grey-400': '#7983BB',
            'grey-500': '#8692D0',
            'grey-600': '#AAB3DE',
            'grey-700': '#B6BEE3',
            'grey-800': '#CFD3EC',
            'grey-900': '#E7E9F6',
            'perfect-scrollbar-thumb': '#4a5072',
            'skin-bordered-background': '#312d4b',
            'skin-bordered-surface': '#312d4b',
            'expansion-panel-text-custom-bg': '#373350',
            'track-bg': '#474360',
            'chat-bg': '#373452',

            'sky-blue': '#58A1D5',
            'deep-sky-blue': '#3587C2',
            'navy-blue': '#1F5685',
            'steel-blue': '#256BA4',
            tangerine: '#F58145',
            ivory: '#FFFEEA',
            'dark-charcoal': '#2F2F2F',
            'wood-charcoal': '#464646',
            'spanish-gray': '#989898',
            'traffic-red': '#ED151B',
        },
        variables: {
            'code-color': '#d400ff',
            'overlay-scrim-background': '#312D4B',
            'tooltip-background': '#F7F4FF',
            'overlay-scrim-opacity': 0.5,
            'hover-opacity': 0.04,
            'focus-opacity': 0.1,
            'selected-opacity': 0.08,
            'activated-opacity': 0.16,
            'pressed-opacity': 0.14,
            'disabled-opacity': 0.4,
            'dragged-opacity': 0.1,
            'border-color': '#E7E3FC',
            'border-opacity': 0.12,
            'table-header-color': '#3D3759',
            'high-emphasis-opacity': 0.9,
            'medium-emphasis-opacity': 0.7,

            // 👉 Shadows
            'shadow-key-umbra-color': '#131120',
            'shadow-xs-opacity': '0.20',
            'shadow-sm-opacity': '0.22',
            'shadow-md-opacity': '0.24',
            'shadow-lg-opacity': '0.26',
            'shadow-xl-opacity': '0.28',

            'nav-bg-color': '#F3F7FC',
            'inactive-color': '#525252',
        },
    },
}
export default themes
